var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { validateVal } from "./numberMethods";
export var updateHolding = function (data, streamData) {
    var holdingDetails = data.HoldingDetails.map(function (holding) {
        if (holding.quote.symbol === streamData.symbol &&
            holding.quote.lastTradedPrice.toString() !==
                streamData.curPrice.toString()) {
            var actualCP = actualChangePrice(holding.quote.change.valueOf(), streamData.changePrice);
            var pnl = pnlCalculate(streamData.curPrice, holding.averagePrice.valueOf(), holding.quantity.valueOf(), holding.pnl.valueOf());
            var dayPnlStock = dayPnlCal(streamData.curPrice, holding.previousClosingValue.valueOf(), holding.quantity.valueOf());
            var curVal = calCurVal(streamData.curPrice, Number(holding.quantity));
            data.HoldingSummary.currentValue = totalCurValue(data.HoldingSummary.currentValue.valueOf(), actualCP, holding.quantity.valueOf());
            data.HoldingSummary.totalPnL = totalPnlCal(data.HoldingSummary.currentValue, data.HoldingSummary.totalInvestment.valueOf());
            data.HoldingSummary.totalPnLChange = totalPnlPerc(data.HoldingSummary.totalPnL, data.HoldingSummary.totalInvestment.valueOf());
            data.HoldingSummary.daysPnL = totalDayPnl(data.HoldingSummary.daysPnL.valueOf(), holding.dayChange.valueOf(), dayPnlStock);
            data.HoldingSummary.daysPnLChange = totalDaysPnlPerc(data.HoldingSummary.daysPnL.valueOf(), data.HoldingSummary.totalPreviousClosingValue.valueOf());
            var ltp = validateVal(streamData.curPrice)
                ? holding.quote.lastTradedPrice
                : Number(streamData.curPrice);
            return __assign(__assign({}, holding), { quote: __assign(__assign({}, holding.quote), { lastTradedPrice: ltp, change: validateVal(streamData.changePrice)
                        ? holding.quote.change
                        : Number(streamData.changePrice), changePercentage: validateVal(streamData.changePercentage)
                        ? holding.quote.changePercentage
                        : Number(streamData.changePercentage) }), dayChange: dayPnlStock, pnl: pnl, pnlChangePercentage: pnlPerCal(streamData.curPrice, holding.averagePrice.valueOf(), holding.pnlChangePercentage.valueOf()), currentValue: curVal.valueOf() });
        }
        return holding;
    });
    data.HoldingDetails = holdingDetails;
    return data;
};
export var actualChangePrice = function (prevCP, curCP) {
    if (validateVal(prevCP) || validateVal(curCP))
        return "";
    return Number(curCP) - Number(prevCP);
};
export var pnlCalculate = function (curP, avgP, qty, defaultVal) {
    try {
        if (validateVal(curP)) {
            return defaultVal ? defaultVal.toString() : "";
        }
        if (validateVal(avgP) || validateVal(qty)) {
            return "";
        }
        return ((Number(curP) - Number(avgP)) * Number(qty)).toFixed(2).toString();
    }
    catch (error) {
        return "";
    }
};
export var calCurVal = function (lastTradedPrice, qty) {
    try {
        if (validateVal(lastTradedPrice) || validateVal(qty))
            return "";
        return (Number(lastTradedPrice) * Number(qty)).toFixed(2).toString();
    }
    catch (error) {
        return "";
    }
};
export var pnlPerCal = function (curP, avgP, defaultVal) {
    try {
        if (validateVal(curP) || validateVal(avgP)) {
            return defaultVal ? defaultVal.toString() : "";
        }
        return (((Number(curP) - Number(avgP)) / Number(avgP)) * 100)
            .toFixed(2)
            .toString();
    }
    catch (error) {
        return defaultVal ? defaultVal.toString() : "";
    }
};
export var totalPnlCal = function (curVal, totalInv) {
    try {
        if (validateVal(curVal) || validateVal(totalInv)) {
            return "";
        }
        return (Number(curVal) - Number(totalInv)).toFixed(2).toString();
    }
    catch (error) {
        return "";
    }
};
export var totalPnlPerc = function (totalPnl, totalInv) {
    try {
        if (validateVal(totalPnl) ||
            validateVal(totalInv) ||
            totalPnl === 0 ||
            totalInv === 0) {
            return "";
        }
        return ((Number(totalPnl) / Number(totalInv)) * 100).toFixed(2).toString();
    }
    catch (error) {
        return "";
    }
};
export var sumOfTwo = function (val1, val2) {
    try {
        if (validateVal(val1) || validateVal(val2)) {
            return Number(val1);
        }
        return Number(val1) + Number(val2);
    }
    catch (error) {
        return Number(val1);
    }
};
export var dayChangeCal = function (prevClosed, curP, defaultVal) {
    try {
        if (validateVal(prevClosed) || validateVal(curP)) {
            return defaultVal ? defaultVal.toString() : "";
        }
        return (Number(prevClosed) - Number(curP)).toFixed(2).toString();
    }
    catch (error) {
        return defaultVal ? defaultVal.toString() : "";
    }
};
export var dayPnlCal = function (curP, prevClosed, qty, defaultVal) {
    try {
        if (validateVal(curP) || validateVal(prevClosed))
            return defaultVal ? defaultVal.toString() : "";
        return (Number(Number(curP) * Number(qty)) - Number(prevClosed))
            .toFixed(2)
            .toString();
    }
    catch (error) {
        return defaultVal ? defaultVal.toString() : "";
    }
};
// export const totalDayPnl = (
//   totalPrevClosedVal: string | number,
//   totalCurVal: string | number,
//   defaultVal?: string | number
// ): string => {
//   try {
//     if (validateVal(totalPrevClosedVal) || validateVal(totalCurVal))
//       return defaultVal ? defaultVal.toString() : "";
//     return (Number(totalPrevClosedVal) - Number(totalCurVal))
//       .toFixed(2)
//       .toString();
//   } catch (error) {
//     return defaultVal ? defaultVal.toString() : "";
//   }
// };
export var totalDayPnl = function (prevTotalDayPnl, prevStockDayPnl, stockDayPnl) {
    if (validateVal(prevTotalDayPnl)) {
        return 0;
    }
    if (validateVal(prevStockDayPnl) || validateVal(stockDayPnl)) {
        return prevTotalDayPnl;
    }
    return (Number(prevTotalDayPnl) + (Number(stockDayPnl) - Number(prevStockDayPnl)));
};
export var totalCurValue = function (totalcurVal, chgP, qty) {
    try {
        if (validateVal(totalcurVal) || validateVal(chgP) || validateVal(qty)) {
            return totalcurVal ? totalcurVal.toString() : "";
        }
        return (Number(totalcurVal) + Number(Number(chgP) * Number(qty)))
            .toFixed(2)
            .toString();
    }
    catch (error) {
        return totalcurVal ? totalcurVal.toString() : "";
    }
};
// export const totalDaysPnlPerc = (
//   totalcurVal: string | number,
//   totalPrevClosed: string | number
// ): string => {
//   try {
//     if (validateVal(totalcurVal) || validateVal(totalPrevClosed)) {
//       return "";
//     }
//     return (
//       ((Number(totalcurVal) - Number(totalPrevClosed)) /
//         Number(totalPrevClosed)) *
//       100
//     )
//       .toFixed(2)
//       .toString();
//   } catch (error) {
//     return "";
//   }
// };
export var totalDaysPnlPerc = function (totaldaysPnl, totalPrevClosed) {
    try {
        if (validateVal(totaldaysPnl) ||
            validateVal(totalPrevClosed) ||
            totaldaysPnl === 0 ||
            totalPrevClosed === 0) {
            return "";
        }
        return ((Number(totaldaysPnl) / Number(totalPrevClosed)) * 100)
            .toFixed(2)
            .toString();
    }
    catch (error) {
        return "";
    }
};
